import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import Header from "./components/Header";
import Protected from "./components/Protected";
import GuestOnly from "./components/GuestOnly";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Catalog from "./pages/Catalog";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Orders from "./pages/Orders";
import OrderDetail from "./pages/OrderDetail";
import ProductDetail from "./pages/ProductDetail";
import Account from "./pages/Account";
import AdminMembers from "./pages/admin/Members";
import AdminOrders from "./pages/admin/Orders";
import AdminSuppliers from "./pages/admin/Suppliers";
import AdminPayments from "./pages/admin/Payments";
import AdminStock from "./pages/admin/Stock";
import AdminProducts from "./pages/admin/Products";
import AdminLayout from "./pages/admin/Layout";

// xlsx 의존성을 admin Import 페이지에만 로드 (메인 번들 경량화)
const AdminImport = lazy(() => import("./pages/admin/Import"));

export default function App() {
  return (
    <>
      <a href="#main-content" className="skip-nav">본문으로 바로가기</a>
      <Header />
      <Routes>
        <Route path="/" element={<GuestOnly><Landing /></GuestOnly>} />
        <Route path="/login" element={<GuestOnly><Login /></GuestOnly>} />
        <Route path="/signup" element={<GuestOnly><Signup /></GuestOnly>} />
        <Route path="/catalog" element={<Protected customerOnly><Catalog /></Protected>} />
        <Route path="/catalog/:sku" element={<Protected customerOnly><ProductDetail /></Protected>} />
        <Route path="/cart" element={<Protected customerOnly><Cart /></Protected>} />
        <Route path="/checkout" element={<Protected customerOnly><Checkout /></Protected>} />
        <Route path="/orders" element={<Protected customerOnly><Orders /></Protected>} />
        <Route path="/orders/:id" element={<Protected customerOnly><OrderDetail /></Protected>} />
        <Route path="/account" element={<Protected><Account /></Protected>} />
        <Route path="/admin" element={<Protected admin><AdminLayout /></Protected>}>
          <Route index element={<AdminMembers />} />
          <Route path="members" element={<AdminMembers />} />
          <Route path="products" element={<AdminProducts />} />
          <Route path="suppliers" element={<AdminSuppliers />} />
          <Route path="orders" element={<AdminOrders />} />
          <Route path="payments" element={<AdminPayments />} />
          <Route path="stock" element={<AdminStock />} />
          <Route path="import" element={<Suspense fallback={<div className="muted">로딩...</div>}><AdminImport /></Suspense>} />
        </Route>
      </Routes>
    </>
  );
}
